import ReceivedAtDate from '../../../../../components/ReceivedAtDate';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment, { now } from 'moment-timezone';

import { TIME_FORMAT_12_UPPERCASE, DATE_MONTH_DAY_YEAR, PAGE_LIMIT } from '../../../../../constants';
import Table3, { columnHelper } from '../../../../../containers/Table/Table3';
import { actions, PLOT_DATA_RESULT } from '../Graph/actions';
import Strings from '../../../../../Strings';
import { PageHeader } from '../../../../../components/PageHeader';
import { Button } from '../../../../../components/PageHeader/Button';
import { HAILIE_INHALER } from '../../constant';
import { hailieEventSubTypeDisplay } from '../../../../../utils';

function HailieInhalerTable(props) {
  const pageRequest = useRef({
    offset: 0,
    startDate: props.startDate,
    endDate: props.endDate,
    deviceId: props.deviceId,
    dataType: HAILIE_INHALER,
    limit: PAGE_LIMIT,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [refreshEnable, setRefreshEnable] = useState(true);
  const [refreshTimestamp, setRefreshTimestamp] = useState(now());

  useEffect(() => {
    pageRequest.current.startDate = props.startDate;
    pageRequest.current.endDate = props.endDate;
    pageRequest.current.deviceId = props.deviceId;
    pageRequest.current.hubId = props.hubId;
    pageRequest.current.kitId = props.kitId;
    pageRequest.current.patientId = props.patientId;

    getEvents();
  }, [refreshTimestamp, props.deviceId, props.startDate, props.endDate, props.hubId, props.kitId]);

  const onRefresh = () => {
    setRefreshEnable(false);
    setTimeout(() => {
      setRefreshEnable(true);
    }, 10000);
    setRefreshTimestamp(now());
  };

  const getEvents = () => {
    setIsLoading(true);
    props.getEvents(pageRequest.current, props.hubId, props.deviceId).then(resp => {
      if (resp.type === PLOT_DATA_RESULT) {
        setData(resp.response.data.sort((a, b) => b.timestamp - a.timestamp));
      }
      setIsLoading(false);
    });
  };

  const physioParamsDisplay = data => {
    let ret = '';
    data.forEach(e => {
      ret += `${e.name}: ${e.value}, `;
    });
    return ret;
  };

  const columns = React.useMemo(() => [
    columnHelper.accessor('date', {
      accessorFn: row => row.timestamp,
      header: Strings.date,
      cell: info => (
        <ReceivedAtDate
          measuredAt={info.getValue() ? moment.unix(info.getValue()) : null}
          backendTimestamp={info.row.original.backend_timestamp}
          displayFormat={`${DATE_MONTH_DAY_YEAR} ${TIME_FORMAT_12_UPPERCASE}`}
        >
          {moment.unix(info.getValue()).format(DATE_MONTH_DAY_YEAR)}
        </ReceivedAtDate>
      ),
      size: 120,
    }),
    columnHelper.accessor('time', {
      accessorFn: row => row.timestamp,
      header: Strings.time,
      cell: info => moment.unix(info.getValue()).format(TIME_FORMAT_12_UPPERCASE),
      size: 120,
    }),
    columnHelper.accessor('event_sub_type', {
      header: Strings.eventType,
      cell: info => hailieEventSubTypeDisplay(info.getValue()),
      size: 150,
    }),
    columnHelper.accessor('physio_params', {
      header: Strings.physioParams,
      cell: info => physioParamsDisplay(info.getValue()),
      size: 250,
    }),
  ], []);

  const getPageHeader = () => {
    const { dateRangeSelect } = props;

    return (
      <PageHeader
        right={
          <React.Fragment>
            <Button class="refreshTop" disabled={!refreshEnable} onClick={onRefresh} />
            {dateRangeSelect}
          </React.Fragment>
        }
      />
    );
  };

  return (
    <React.Fragment>
      {getPageHeader()}
      <Table3
        name="hailie-inhaler-table"
        uuid="297320e8-3a47-4b80-911b-007270d582ee"
        data={data}
        columns={columns}
        isLoading={isLoading}
        enableColumnFiltering
      />
    </React.Fragment>
  );
}

HailieInhalerTable.propTypes = {
  deviceId: PropTypes.string.isRequired,
  patientId: PropTypes.string,
  hubId: PropTypes.string,
  kitId: PropTypes.string,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  getEvents: PropTypes.func.isRequired,
  dateRangeSelect: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
  getEvents: pageRequest => dispatch(actions.getPlotData(pageRequest)),
});

export default connect(null, mapDispatchToProps)(HailieInhalerTable);
